export default __webpack_public_path__ + "static/media/u2.d6a0267f.jpg";